// extracted by mini-css-extract-plugin
export var active = "_61-a";
export var activeIndicator = "_61-8";
export var animate = "_61-9";
export var disabled = "_61-b";
export var fullWidth = "_61-2";
export var lg = "_61-7";
export var md = "_61-6";
export var redoButtonTabGroup = "_61-0";
export var sm = "_61-5";
export var tabButton = "_61-3";
export var tabButtonsContainer = "_61-1";
export var xs = "_61-4";